import React from 'react';

export default [
  {
    title: 'Amenities',
    data: (
      <ul>
        <li>30,000 sf Outdoor Garden Space</li>
        <li>Elegant Entrance Landscaped with Water Features</li>
        <li>2nd, 4th, and 5th Floor Outdoor Courtyards</li>
        <li>Workspace and Meeting Room</li>
        <li>Spacious Lounge with Kitchen and Outdoor Fireplace</li>
        <li>Community Urban Garden</li>
        <li>Pet Wash Station</li>
        <li>Fitness Gym with Outdoor Courtyard</li>
        <li>Guest Suite for Friends and Family</li>
        <li>On-site Car Share</li>
        <li>Pocket Park with Water Features</li>
        <li>Mailroom and Parcel Drop-off</li>
        <li>Large Underground Storage Lockers</li>
        <li>Concierge Desk</li>
        <li>5th Floor Outdoor Play Area</li>
      </ul>
    ),
  },
  {
    title: 'Kitchens',
    data: (
      <ul>
        <li>Kitchen Under-cabinet Lighting</li>
        <li>Kohler Double Under-mount Sink</li>
        <li>Polished Quartz Countertops</li>
        <li>Porcelain Backsplash</li>
        <li>Stainless Steel Appliances</li>
      </ul>
    ),
  },
  {
    title: 'Studio & 1 Bedroom',
    data: (
      <ul className="larger-list">
        <li>24” Bosch Gas Cook Top</li>
        <li>24” Bosch Wall Oven</li>
        <li>24” Bosch Pull-Out Hood</li>
        <li>24” Bosch Custom Panel Bottom Freezer Refrigerator</li>
        <li>22” Built-in Panasonic Microwave</li>
        <li>24” Bosch Dishwasher</li>
        <li>Samsung Washer &amp; Dryer</li>
      </ul>
    ),
  },
  {
    title: '2 & 3 Bedroom',
    data: (
      <ul className="larger-list">
        <li>30” Bosch Gas Cook Top</li>
        <li>30” Bosch Wall Oven</li>
        <li>30” Bosch Pull-Out Hood</li>
        <li>30” Bosch Custom Panel Bottom Freezer Refrigerator</li>
        <li>22” Built-in Panasonic Microwave</li>
        <li>24” Bosch Dishwasher</li>
        <li>LG Front Loading Washer &amp; Dryer</li>
      </ul>
    ),
  },
  {
    title: 'Bathrooms',
    data: (
      <ul className="larger-list">
        <li>Kohler Fixtures</li>
        <li>Porcelain Tiles</li>
        <li>Contemporary Cabinetry</li>
        <li>Polished Caesarstone Countertops</li>
      </ul>
    ),
  },
  {
    title: 'Convenient & Secure Living',
    data: (
      <ul className="larger-list">
        <li>
          Minutes to New Westminster and Columbia Skytrain Station for Quick
          Access to Downtown, Metrotown, and Surrey Central
        </li>
        <li>Steps to Shops and Restaurants on Columbia Street</li>
        <li>Quick Access to Downtown and Richmond via multiple Bus Lines</li>
        <li>School Catchment for all levels of Education</li>
        <li>Fob and Key exclusive access to Parkade</li>
        <li>Organize life effortlessly at the Concierge Desk</li>
        <li>2-5-10 National Home Warranty</li>
      </ul>
    ),
  },
];



// WEBPACK FOOTER //
// ./src/data/interior.js